// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"68":"700918","225":"41d239","956":"2f1431"}[chunkId] + ".css";
};